// ====================================================================
// 1. GLOBAL CONFIGURATIONS (Can be overridden in theme/custom scripts)
// ====================================================================

window.TIB_TRANSLATIONS = window.TIB_TRANSLATIONS || {
  en: {
    ai_title: "Your artwork is coming to life...",
    ai_heading_sub: "Our AI is transforming your photo into a unique piece of art.",
    editor_title: "Preparing your photo...",
    editor_heading_sub: "Your photo is being prepared for the AI.",
    upload_placeholder: "Choose your photo to upload",
    replace_btn: "Replace photo",
    time_estimate_prefix: "Estimated time",
    time_estimate: "Usually about 45–60 seconds",
    thanks_patience: "Thanks for your patience!",
    great_art: "Great artwork deserves a little time.",
    did_you_know: "Did you know?",
    did_you_know_text: "Every artwork is created exclusively for you and professionally printed in Germany.",
    made_for_you: "Created just for you",
    step_done: "Done",
    step_pending: "Pending",
    steps: [
      {
        title: "Analyzing your photo...",
        sub: "Checking image quality and preparing it for the AI."
      },
      {
        title: "Creating your artwork...",
        sub: "Our AI is turning your photo into something truly unique."
      },
      {
        title: "Adding the finishing touches...",
        sub: "Enhancing colors, details and artistic effects."
      },
      {
        title: "Optimizing for premium print...",
        sub: "Preparing your artwork for the best possible print quality."
      },
      {
        title: "Almost there...",
        sub: "Your masterpiece will be ready in just a few seconds."
      }
    ]
  },

  de: {
    ai_title: "Dein Kunstwerk entsteht...",
    ai_heading_sub: "Unsere KI verwandelt dein Foto jetzt Schritt für Schritt in ein einzigartiges Kunstwerk voller Details und Charakter.",
    editor_title: "Dein Foto wird vorbereitet...",
    editor_heading_sub: "Dein Foto wird für die KI vorbereitet.",
    upload_placeholder: "Wähle dein Foto zum Hochladen aus",
    replace_btn: "Foto ersetzen",
    time_estimate_prefix: "Geschätzte Dauer",
    time_estimate: "Meist etwa 45–60 Sekunden",
    thanks_patience: "Vielen Dank für deine Geduld!",
    great_art: "Ein besonderes Kunstwerk braucht einen kleinen Moment.",
    did_you_know: "Wusstest du schon?",
    did_you_know_text: "Jedes Kunstwerk wird ausschließlich für dich erstellt und anschließend professionell in Deutschland gedruckt.",
    did_you_know_texts: [
    "Jedes Kunstwerk wird individuell aus deinem Foto erstellt.",
    "Unsere KI erschafft dein Design Schritt für Schritt neu.",
    "Kein Kunstwerk gleicht dem anderen – jedes Motiv ist ein Unikat.",
    "Aus deinem Foto entsteht gerade etwas ganz Besonderes.",
    "Dein Kunstwerk wird speziell für den gewählten Style erstellt.",
    "Farben, Details und Effekte werden sorgfältig aufeinander abgestimmt.",

    "Seit über 35 Jahren stehen Textildruck, Grafik und Veredelung für unsere Leidenschaft.",
    "Dein Kunstwerk wird professionell in Deutschland gedruckt und veredelt.",
    "Vor dem Druck wird dein Motiv für ein optimales Ergebnis vorbereitet.",
    "Viele Bestellungen machen sich bereits nach wenigen Tagen auf den Weg zu ihren neuen Besitzern.",
    "Qualität steht bei uns vor Geschwindigkeit.",
    "Jedes Produkt wird mit großer Sorgfalt gefertigt und geprüft.",

    "Dein Design kannst du später auch auf Tassen, Kissen und Postern bestellen.",
    "Mit einem Klick kannst du dein Kunstwerk auf weiteren Produkten entdecken.",
    "Viele unserer Designs wirken auf unterschiedlichen Produkten völlig unterschiedlich.",
    "Je nach Style und Produkt wird dein Motiv optimal für den Druck vorbereitet.",
    "Bei vielen Styles wird der Hintergrund automatisch für das jeweilige Produkt optimiert.",
    "Ein Motiv – viele Möglichkeiten.",

    "Du kommst aus der Region? Gerne kannst du deine Bestellung auch persönlich bei uns abholen.",
    "Jeden Tag verlassen zahlreiche personalisierte Produkte unsere Produktion.",
    "Aus einer Idee entsteht bei uns ein echtes Lieblingsprodukt.",
    "Vielleicht entsteht gerade dein neues Lieblingsshirt.",
    "In wenigen Augenblicken entdeckst du dein persönliches Kunstwerk.",
    "Der schönste Moment kommt gleich – wenn dein fertiges Kunstwerk zum ersten Mal erscheint."
  ],
    made_for_you: "Exklusiv für dich",
    step_done: "Fertig",
    step_pending: "Ausstehend",
    steps: [
      {
        title: "Dein Foto wird analysiert...",
        sub: "Wir prüfen dein Bild und bereiten es für die KI vor."
      },
      {
        title: "Dein Kunstwerk entsteht...",
        sub: "Unsere KI verwandelt dein Foto jetzt Schritt für Schritt in ein einzigartiges Kunstwerk voller Details und Charakter."
      },
      {
        title: "Der Feinschliff beginnt...",
        sub: "Farben, Details und Effekte werden perfektioniert."
      },
      {
        title: "Optimierung für Premium-Druck...",
        sub: "Dein Kunstwerk wird für ein brillantes Druckergebnis vorbereitet."
      },
      {
        title: "Fast geschafft...",
        sub: "Nur noch wenige Sekunden, dann erwartet dich dein ganz persönliches Kunstwerk mit einem echten WOW-Moment."
      }
    ]
  }
};

// --- Popup visual config — override in theme/custom scripts ---
// Set productImageUrl to your CDN URL to show a product image in the left panel.
// stepThresholds controls at what fake-progress % each step becomes "active".
//
// NOTE: uses Object.assign so a value set earlier (e.g. by a Liquid <script>
// in the product template setting productImageUrl from a metafield) wins,
// while these defaults still fill in anything not provided (like stepThresholds).
window.TIB_POPUP_CONFIG = Object.assign(
  {
    productImageUrl: 'https://cdn.shopify.com/s/files/1/0881/5525/9215/files/Default_Bild_1_Popup.jpg?v=1792932976',
    stepThresholds: [0, 10, 65, 78, 90],
  },
  window.TIB_POPUP_CONFIG || {}
);

window.TIB_DEBUG = false;

function tibLog(...args) {
  if (window.TIB_DEBUG) {
    console.log('[TIB Debug]', ...args);
  }
}

// --- AI Layer Detection for non-percent based fields ---
window.tibAiLayerData = window.tibAiLayerData || new Map();

function parseCampaignObject(campaign) {
  if (!campaign || !Array.isArray(campaign.artworks)) return false;

  const processLayers = (layers) => {
    if (!Array.isArray(layers)) return;
    layers.forEach(layer => {
      let isMagicAi = false;
      let isEditorAi = false;

      const hasRemoveBg = layer.remove_bg === true || layer.remove_bg === 1;

      if (Array.isArray(layer.effects)) {
        isMagicAi = layer.effects.some(effect => (effect.type || "").includes("image_filter"));
        isEditorAi = layer.effects.some(effect => /background_remover|face_cutout|gray_scale|contour_cut|photo_enhancer|watercolor|portrait_sketch/.test(effect.type || ""));
      }

      if (isMagicAi) {
        window.tibAiLayerData.set(String(layer.id), 'ai');
      } else if (hasRemoveBg || isEditorAi) {
        window.tibAiLayerData.set(String(layer.id), 'editor');
      } else if (layer.type === 'multiple-uploads' && layer.multi_image_provider) {
        window.tibAiLayerData.set(String(layer.id), 'ai');
      } else if (layer.type === 'text-to-image' && layer.text_to_image_provider) {
        window.tibAiLayerData.set(String(layer.id), 'ai');
      }
    });
  };

  campaign.artworks.forEach(artwork => {
    if (artwork.data) {
      artwork.data.forEach(template => {
        processLayers(template.layers);
      });
    }
  });

  return true;
}

function handleCampaignEvent(e) {
  const detail = e.detail;
  if (!detail) return;
  const campaign = detail.campaign || detail.campaignData || detail;
  parseCampaignObject(campaign);
}

// Intercept Teeinblue's own network fetch safely
(function () {
  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const url = args[0];
    const response = await originalFetch.apply(window, args);
    if (typeof url === 'string' && url.includes('.json') && (url.includes('/campaigns/') || url.includes('/platform-products/') || url.includes('api.teeinblue.com'))) {
      try {
        const clone = response.clone();
        clone.json().then(data => {
          if (data && Array.isArray(data.artworks)) parseCampaignObject(data);
        }).catch(() => {});
      } catch (e) {}
    }
    return response;
  };
})();

async function fetchCampaignData() {
  try {
    const shop = window.Shopify?.shop || window.location.hostname;
    const campaignConfig = window.teeinblueCampaign || window.TeeInBlueCampaign;
    if (!campaignConfig) return;
    const productId = campaignConfig.productId;
    if (!productId) return;
    const isPlatform = campaignConfig.isPlatformProduct === true;
    const version = campaignConfig.version || 1;
    const endpoint = isPlatform ? 'platform-products' : 'campaigns';
    const response = await fetch(`https://staging-api.teeinblue.com/api/merchant/${endpoint}/${productId}.json?shop=${shop}&v=${version}`);
    if (!response.ok) return;
    const data = await response.json();
    parseCampaignObject(data);
  } catch (e) {
    console.error("Teeinblue AI Campaign parser error:", e);
  }
}

document.addEventListener("teeinblue-event-campaign-loaded", handleCampaignEvent);
document.addEventListener("teeinblue-event-component-injected", handleCampaignEvent);

if (document.readyState === "complete" || document.readyState === "interactive") {
  setTimeout(() => { if (window.tibAiLayerData.size === 0) fetchCampaignData(); }, 1500);
} else {
  window.addEventListener("load", () => {
    setTimeout(() => { if (window.tibAiLayerData.size === 0) fetchCampaignData(); }, 1500);
  });
}

// ====================================================================
// 2. MAIN UPLOAD / POPUP LOGIC
// ====================================================================

function initCustomUpload() {
  if (window._tibCustomUploadInitialized) return;
  window._tibCustomUploadInitialized = true;

  const translations = window.TIB_TRANSLATIONS;
  const lang = window.TIB_LOCALE || document.documentElement.lang || 'en';
  const locale = lang.substring(0, 2).toLowerCase();
  const t = translations[locale] || translations.en;

  const ai_title     = t.ai_title     || "Your artwork is being created...";
  const editor_title = t.editor_title || "Processing your photo...";

  // Custom icon overrides (supports raw HTML/SVG strings)
  const ai_icon     = t.ai_icon     || window.TIB_AI_ICON     || null;
  const editor_icon = t.editor_icon || window.TIB_EDITOR_ICON || null;

  // ── Header wand / paintbrush icon ──────────────────────────────────
  const WAND_SVG = `<svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" version="1.1" viewBox="0 0 48 48" width="48" height="48"> <defs> <style> .st0 { stroke-linecap: round; } .st0, .st1 { fill: none; stroke: #794ee8; stroke-linejoin: round; stroke-width: 3px; } </style> </defs> <path class="st0" d="M6,42l20-20M36,12l-5,5"/> <path class="st1" d="M19,4l1.89,5.11,5.11,1.89-5.11,1.89-1.89,5.11-1.89-5.11-5.11-1.89,5.11-1.89,1.89-5.11Z"/> <path class="st1" d="M38,20l1.08,2.92,2.92,1.08-2.92,1.08-1.08,2.92-1.08-2.92-2.92-1.08,2.92-1.08,1.08-2.92Z"/> </svg>`;

  const EDITOR_WAND_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none"><rect x="3" y="3" width="18" height="18" rx="2" stroke="url(#tibHG2)" stroke-width="1.8"/><circle cx="8.5" cy="8.5" r="1.5" stroke="url(#tibHG2)" stroke-width="1.5"/><path d="m21 15-5-5L5 21" stroke="url(#tibHG2)" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><defs><linearGradient id="tibHG2" x1="2" y1="2" x2="22" y2="22" gradientUnits="userSpaceOnUse"><stop offset="0%" stop-color="#794ee8"/><stop offset="100%" stop-color="#c084fc"/></linearGradient></defs></svg>`;

  // ── Step icons (stroke="currentColor", sized via CSS) ──────────────
  const STEP_ICONS = [
    `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="3"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="m21 15-5-5L5 21"/></svg>`,
    `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M18.4 4.2a1 1 0 0 0-1.4 0L4.2 17c-.4.4-.4 1 0 1.4l1.4 1.4c.4.4 1 .4 1.4 0L19.8 5.6a1 1 0 0 0 0-1.4l-1.4-1.4z"/><path d="M5.5 18.5 3 21l2.5-1 1-2.5z"/><path d="m14 6 4 4"/></svg>`,
    `<svg fill="currentcolor" width="40" height="40" viewBox="0 0 512 512" id="icons"><path d="M208,512a24.84,24.84,0,0,1-23.34-16l-39.84-103.6a16.06,16.06,0,0,0-9.19-9.19L32,343.34a25,25,0,0,1,0-46.68l103.6-39.84a16.06,16.06,0,0,0,9.19-9.19L184.66,144a25,25,0,0,1,46.68,0l39.84,103.6a16.06,16.06,0,0,0,9.19,9.19l103,39.63A25.49,25.49,0,0,1,400,320.52a24.82,24.82,0,0,1-16,22.82l-103.6,39.84a16.06,16.06,0,0,0-9.19,9.19L231.34,496A24.84,24.84,0,0,1,208,512Zm66.85-254.84h0Z"/><path d="M88,176a14.67,14.67,0,0,1-13.69-9.4L57.45,122.76a7.28,7.28,0,0,0-4.21-4.21L9.4,101.69a14.67,14.67,0,0,1,0-27.38L53.24,57.45a7.31,7.31,0,0,0,4.21-4.21L74.16,9.79A15,15,0,0,1,86.23.11,14.67,14.67,0,0,1,101.69,9.4l16.86,43.84a7.31,7.31,0,0,0,4.21,4.21L166.6,74.31a14.67,14.67,0,0,1,0,27.38l-43.84,16.86a7.28,7.28,0,0,0-4.21,4.21L101.69,166.6A14.67,14.67,0,0,1,88,176Z"/><path d="M400,256a16,16,0,0,1-14.93-10.26l-22.84-59.37a8,8,0,0,0-4.6-4.6l-59.37-22.84a16,16,0,0,1,0-29.86l59.37-22.84a8,8,0,0,0,4.6-4.6L384.9,42.68a16.45,16.45,0,0,1,13.17-10.57,16,16,0,0,1,16.86,10.15l22.84,59.37a8,8,0,0,0,4.6,4.6l59.37,22.84a16,16,0,0,1,0,29.86l-59.37,22.84a8,8,0,0,0-4.6,4.6l-22.84,59.37A16,16,0,0,1,400,256Z"/></svg>`,
    `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8"/></svg>`,
    `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>`,
  ];

  const CHECK_SVG = `<svg viewBox="0 0 12 10" fill="none"><path d="M1.5 5 4.5 8 10.5 1.5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

  // 8-dot circular fading spinner for active step (light to dark clockwise for leading motion)
  const DOT_SPINNER_SVG = `<svg class="tib-step-dot-spinner" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="2.5" r="1.8" fill="#794ee8" opacity="0.125"/><circle cx="18.7" cy="5.3" r="1.8" fill="#794ee8" opacity="0.25"/><circle cx="21.5" cy="12" r="1.8" fill="#794ee8" opacity="0.375"/><circle cx="18.7" cy="18.7" r="1.8" fill="#794ee8" opacity="0.5"/><circle cx="12" cy="21.5" r="1.8" fill="#794ee8" opacity="0.625"/><circle cx="5.3" cy="18.7" r="1.8" fill="#794ee8" opacity="0.75"/><circle cx="2.5" cy="12" r="1.8" fill="#794ee8" opacity="0.875"/><circle cx="5.3" cy="5.3" r="1.8" fill="#794ee8" opacity="1"/></svg>`;

  // State tracker to prevent redundant SVG re-renders (preserves animation state)
  let activePopupMode = null;

  function updatePopupMode(hasAi) {
    const modalTitleEl  = aiBackdrop ? aiBackdrop.querySelector('.tib-ai-modal-title') : null;
    const svgContainerEl = aiBackdrop ? aiBackdrop.querySelector('.tib-ai-video-container') : null;
    const subtitleEl    = aiBackdrop ? aiBackdrop.querySelector('.tib-ai-subtext') : null;
    if (!modalTitleEl) return;

    if (hasAi) {
      if (modalTitleEl.textContent !== ai_title) modalTitleEl.textContent = ai_title;
      const sub = t.ai_heading_sub || '';
      if (subtitleEl && subtitleEl.textContent !== sub) subtitleEl.textContent = sub;
      if (svgContainerEl && activePopupMode !== 'ai') {
        svgContainerEl.innerHTML = ai_icon || WAND_SVG;
        activePopupMode = 'ai';
      }
    } else {
      if (modalTitleEl.textContent !== editor_title) modalTitleEl.textContent = editor_title;
      const sub = t.editor_heading_sub || '';
      if (subtitleEl && subtitleEl.textContent !== sub) subtitleEl.textContent = sub;
      if (svgContainerEl && activePopupMode !== 'editor') {
        svgContainerEl.innerHTML = editor_icon || EDITOR_WAND_SVG;
        activePopupMode = 'editor';
      }
    }
  }

  // ── Build steps HTML ────────────────────────────────────────────────
  const steps           = t.steps || [];
  const stepDoneLabel    = t.step_done    || 'Done';
  const stepPendingLabel = t.step_pending || 'Pending';

  const stepsHtml = steps.map((step, i) => {
    const iconContent = step.imgUrl
      ? `<img src="${step.imgUrl}" class="tib-step-icon-img" alt="" />`
      : (STEP_ICONS[i] || '');
    return `
    <div class="tib-popup-step" data-step="${i}" data-state="${i === 0 ? 'active' : 'pending'}">
      <!-- Sub-column 1: Timeline (Number / Checkmark circle + Connector line) -->
      <div class="tib-step-timeline-col">
        <div class="tib-step-num-circle">
          <span class="tib-step-check-inner">${CHECK_SVG}</span>
          <span class="tib-step-num-inner">${i + 1}</span>
        </div>
        ${i < steps.length - 1 ? '<div class="tib-step-line"></div>' : ''}
      </div>

      <!-- Sub-column 2: Larger Step Icon Circle -->
      <div class="tib-step-icon-col">
        <div class="tib-step-icon-circle">
          ${iconContent}
        </div>
        ${i < steps.length - 1 ? '<div class="tib-step-icon-line"></div>' : ''}
      </div>

      <!-- Step Content: Title & Subtitle -->
      <div class="tib-step-body">
        <div class="tib-step-title">${step.title}</div>
        <div class="tib-step-sub">${step.sub}</div>
      </div>

      <!-- Step Status: Done / Dot Spinner / Pending -->
      <div class="tib-step-status">
        <span class="tib-step-done-lbl">${stepDoneLabel}</span>
        <span class="tib-step-spinner">${DOT_SPINNER_SVG}</span>
        <span class="tib-step-pending-lbl">${stepPendingLabel}</span>
      </div>
    </div>
  `;
  }).join('');

  // ── Main popup HTML ─────────────────────────────────────────────────
  const aiPopupHtml = `
    <div class="tib-ai-modal-backdrop" style="opacity: 0">
      <div class="tib-ai-modal-content">
        <button type="button" class="tib-close-btn" aria-label="Close"></button>

        <div class="tib-popup-main-body">

          <!-- Left: artwork preview + patience note -->
          <div class="tib-popup-left">
            <div class="tib-popup-image-wrap">
              <img class="tib-popup-product-img" src="" alt="Preview" style="display:none" />
              <div class="tib-popup-img-placeholder"></div>
            </div>
            <div class="tib-popup-thanks-note">
              <svg class="tib-thanks-heart-icon" viewBox="0 0 24 24" fill="#794ee8" xmlns="http://www.w3.org/2000/svg">
                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
              </svg>
              <div>
                <div class="tib-thanks-title">${t.thanks_patience || 'Thanks for your patience!'}</div>
                <div class="tib-thanks-sub">${t.great_art || 'Great art takes a little time.'}</div>
              </div>
            </div>
          </div>

          <!-- Right: heading + steps -->
          <div class="tib-popup-right">
            <div class="tib-popup-heading">
              <div class="tib-ai-video-container"></div>
              <div class="tib-popup-heading-texts">
                <div class="tib-ai-modal-title">${ai_title}</div>
                <div class="tib-ai-subtext">${t.ai_heading_sub || ''}</div>
              </div>
            </div>
            <div class="tib-popup-steps-list">
              ${stepsHtml}
            </div>
          </div>

        </div><!-- /.tib-popup-main-body -->

        <!-- Progress bar footer -->
        <div class="tib-popup-footer-bar">
          <div class="tib-popup-time-estimate">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
            <span>${t.time_estimate_prefix || 'This usually takes'} <strong class="tib-time-highlight">${t.time_estimate || '60-90 seconds'}</strong></span>
          </div>
          <div class="tib-ai-progress-bar">
            <div class="tib-ai-progress-fill" style="width: 0%"></div>
          </div>
          <span class="tib-ai-percent-text">0%</span>
        </div>

        <!-- Did you know footer card wrapper -->
        <div class="tib-popup-dyk-wrapper">
          <div class="tib-popup-dyk">
            <div class="tib-dyk-left">
              <div class="tib-dyk-icon-circle">
                <svg fill="currentcolor" width="40" height="40" viewBox="0 0 512 512" id="icons"><path d="M208,512a24.84,24.84,0,0,1-23.34-16l-39.84-103.6a16.06,16.06,0,0,0-9.19-9.19L32,343.34a25,25,0,0,1,0-46.68l103.6-39.84a16.06,16.06,0,0,0,9.19-9.19L184.66,144a25,25,0,0,1,46.68,0l39.84,103.6a16.06,16.06,0,0,0,9.19,9.19l103,39.63A25.49,25.49,0,0,1,400,320.52a24.82,24.82,0,0,1-16,22.82l-103.6,39.84a16.06,16.06,0,0,0-9.19,9.19L231.34,496A24.84,24.84,0,0,1,208,512Zm66.85-254.84h0Z"/><path d="M88,176a14.67,14.67,0,0,1-13.69-9.4L57.45,122.76a7.28,7.28,0,0,0-4.21-4.21L9.4,101.69a14.67,14.67,0,0,1,0-27.38L53.24,57.45a7.31,7.31,0,0,0,4.21-4.21L74.16,9.79A15,15,0,0,1,86.23.11,14.67,14.67,0,0,1,101.69,9.4l16.86,43.84a7.31,7.31,0,0,0,4.21,4.21L166.6,74.31a14.67,14.67,0,0,1,0,27.38l-43.84,16.86a7.28,7.28,0,0,0-4.21,4.21L101.69,166.6A14.67,14.67,0,0,1,88,176Z"/><path d="M400,256a16,16,0,0,1-14.93-10.26l-22.84-59.37a8,8,0,0,0-4.6-4.6l-59.37-22.84a16,16,0,0,1,0-29.86l59.37-22.84a8,8,0,0,0,4.6-4.6L384.9,42.68a16.45,16.45,0,0,1,13.17-10.57,16,16,0,0,1,16.86,10.15l22.84,59.37a8,8,0,0,0,4.6,4.6l59.37,22.84a16,16,0,0,1,0,29.86l-59.37,22.84a8,8,0,0,0-4.6,4.6l-22.84,59.37A16,16,0,0,1,400,256Z"/></svg>
              </div>
              <div class="tib-dyk-text">
                <strong>${t.did_you_know || 'Did you know?'}</strong>
                <span>${t.did_you_know_text || 'Each artwork is created especially for you.'}</span>
              </div>
            </div>
            <div class="tib-dyk-signature">${t.made_for_you || 'Made for you!'} ♡</div>
          </div>
        </div>

      </div><!-- /.tib-ai-modal-content -->
    </div><!-- /.tib-ai-modal-backdrop -->
  `;

  // Append HTML to body
  const container = document.createElement('div');
  container.id = 'tib-custom-popups-container';
  container.innerHTML = aiPopupHtml;
  document.body.appendChild(container);

  // ── Element references ──────────────────────────────────────────────
  const aiBackdrop    = container.querySelector('.tib-ai-modal-backdrop');
  const aiModalContent = aiBackdrop.querySelector('.tib-ai-modal-content');
  const percentText   = aiBackdrop.querySelector('.tib-ai-percent-text');
  const progressFill  = aiBackdrop.querySelector('.tib-ai-progress-fill');
  const stepElements  = Array.from(aiBackdrop.querySelectorAll('.tib-popup-step'));
  const productImgEl  = aiBackdrop.querySelector('.tib-popup-product-img');
  const placeholderEl = aiBackdrop.querySelector('.tib-popup-img-placeholder');
  const dykTextEl = aiBackdrop.querySelector('.tib-dyk-text span');

  // TSB-Begin: Wechselnde Hinweistexte
  let dykInterval = null;
  let lastDykIndex = -1;

  function showNextDykText() {
    const texts = Array.isArray(t.did_you_know_texts)
      ? t.did_you_know_texts
      : [];

    if (!dykTextEl || texts.length === 0) return;

    let nextIndex;

    do {
      nextIndex = Math.floor(Math.random() * texts.length);
    } while (texts.length > 1 && nextIndex === lastDykIndex);

    lastDykIndex = nextIndex;
    dykTextEl.textContent = texts[nextIndex];
  }

  function startDykRotation() {
    stopDykRotation();
    showNextDykText();

    dykInterval = setInterval(() => {
      showNextDykText();
    }, 7000);
  }

  function stopDykRotation() {
    if (dykInterval) {
      clearInterval(dykInterval);
      dykInterval = null;
    }
  }
  // TSB-End

  // ── Product image — re-checked on each open so late URL assignment works ──
  function refreshProductImage() {
    const url = (window.TIB_POPUP_CONFIG && window.TIB_POPUP_CONFIG.productImageUrl) || null;
    if (url && productImgEl) {
      productImgEl.src = url;
      productImgEl.style.display = 'block';
      if (placeholderEl) placeholderEl.style.display = 'none';
    } else {
      if (productImgEl) productImgEl.style.display = 'none';
      if (placeholderEl) placeholderEl.style.display = 'block';
    }
  }
  refreshProductImage();

  // Set initial icon and title
  updatePopupMode(true);

  const popupLockClass = 'tib-popup-scroll-lock';

  function syncPopupScrollLock() {
    const shouldLock = aiBackdrop.classList.contains('tib-active');
    document.documentElement.classList.toggle(popupLockClass, shouldLock);
    document.body.classList.toggle(popupLockClass, shouldLock);
  }

  // ── Steps: update data-state based on current fake percent ──────────
  function updateSteps(percent) {
    const config = window.TIB_POPUP_CONFIG || {};
    const thresholds = Array.isArray(config.stepThresholds) ? config.stepThresholds : [0, 20, 45, 70, 88];
    stepElements.forEach((stepEl, i) => {
      const activateAt     = thresholds[i]     !== undefined ? thresholds[i]     : 0;
      const nextThreshold  = thresholds[i + 1] !== undefined ? thresholds[i + 1] : 100;
      let state;
      if (percent >= 100 || percent >= nextThreshold) {
        state = 'done';
      } else if (percent >= activateAt) {
        state = 'active';
      } else {
        state = 'pending';
      }
      if (stepEl.dataset.state !== state) stepEl.dataset.state = state;
    });
  }

  function updateProgress(percent) {
    let val = percent;
    if (typeof val === 'string') val = val.replace('%', '').trim();
    const numVal = Number(val);
    percentText.textContent = `${Math.round(numVal)}%`;
    progressFill.style.width = `${numVal}%`;
    updateSteps(numVal);
  }

  let hideAiTimeout = null;

  function showAiPopup() {
    if (hideAiTimeout) {
      clearTimeout(hideAiTimeout);
      hideAiTimeout = null;
    }
    refreshProductImage();
    startDykRotation();
    if (!aiBackdrop.classList.contains('tib-active')) {
      aiBackdrop.classList.add('tib-active');
      aiModalContent.classList.remove('tib-closing');
    }
    syncPopupScrollLock();
  }

  function hideAiPopup() {
    stopDykRotation();
    
    if (aiBackdrop.classList.contains('tib-active')) {
      if (hideAiTimeout) return;
      hideAiTimeout = setTimeout(() => {
        aiModalContent.classList.add('tib-closing');
        setTimeout(() => {
          aiBackdrop.classList.remove('tib-active');
          hideAiTimeout = null;
          activePopupMode = null; // Reset so icon re-renders fresh on next open
          syncPopupScrollLock();

          // Secretly reset progress + steps while hidden
          progressFill.style.transition = 'none';
          updateProgress(0);
          void progressFill.offsetWidth; // Force reflow
          progressFill.style.transition = '';
        }, 300);
      }, 500); // 500ms delay so the popup stays visible while cropper/placement modal renders
    } else {
      syncPopupScrollLock();
    }
  }

  let isClosedByUser = false;
  const activeLoadingElements = new Set();
  let currentTrackingElement = null;

  // ── Fake progress engine ────────────────────────────────────────────
  let fakeProgressInterval = null;
  let currentFakePercent = 0;
  let targetMax = 95;

  function startFakeProgress() {
    if (fakeProgressInterval) return;

    currentFakePercent = 0;
    targetMax = 95;

    progressFill.style.transition = 'none';
    updateProgress(0);
    void progressFill.offsetWidth;
    progressFill.style.transition = '';

    const startedAt = performance.now();

    const interpolate = (value, startTime, endTime, startPercent, endPercent) => {
      const progress = Math.min(
        1,
        Math.max(0, (value - startTime) / (endTime - startTime))
      );

      return startPercent + (endPercent - startPercent) * progress;
    };

    fakeProgressInterval = setInterval(() => {
      const elapsedSeconds = (performance.now() - startedAt) / 1000;

      let nextPercent;

      if (elapsedSeconds <= 3) {
      // Schritt 1: Fotoanalyse
      nextPercent = interpolate(elapsedSeconds, 0, 3, 0, 10);

    } else if (elapsedSeconds <= 25) {
      // Schritt 2: KI-Generierung
      nextPercent = interpolate(elapsedSeconds, 3, 25, 10, 65);

    } else if (elapsedSeconds <= 32) {
      // Schritt 3: Feinschliff
      nextPercent = interpolate(elapsedSeconds, 25, 32, 65, 78);

    } else if (elapsedSeconds <= 38) {
      // Schritt 4: Druckoptimierung
      nextPercent = interpolate(elapsedSeconds, 32, 38, 78, 90);

    } else if (elapsedSeconds <= 50) {
      // Schritt 5: Fast geschafft
      nextPercent = interpolate(elapsedSeconds, 38, 50, 90, 95);

    } else {
      // Auf tatsächlichen Abschluss warten
      nextPercent = 95;
    }

      currentFakePercent = Math.min(targetMax, nextPercent);
      updateProgress(currentFakePercent);
    }, 200);
  }

  function stopFakeProgress() {
    if (fakeProgressInterval) {
      clearInterval(fakeProgressInterval);
      fakeProgressInterval = null;
    }
  }

  function getAiFieldMode(el) {
    const photoWrapper = el.closest(".tee-photo");
    if (!photoWrapper) return false;

    if (window.tibAiLayerData && window.tibAiLayerData.size > 0) {
    const fileInput = photoWrapper.querySelector("input[type='file']");
    const fieldWrapper = photoWrapper.closest("[class*='tee-field--layer-']");
    const idSource = (fileInput && fileInput.id) || (fieldWrapper && fieldWrapper.className) || '';
    if (idSource) {
      let mode = false;
      window.tibAiLayerData.forEach((layerMode, layerId) => {
        if (layerId && idSource.includes(layerId)) mode = layerMode;
      });
      if (mode) return mode;
    }
    return false; // Strictly block non-AI layers when tibAiLayerData is loaded
    }

    // Fallback: show popup if the element has a processing loader
    if (el.classList.contains('tee-progress--loading') || photoWrapper.querySelector(".tee-progress--loading")) {
      return 'ai';
    }
    return false;
  }

  // ── Monitor Teeinblue form ──────────────────────────────────────────
  let showTimeout = null;

  function checkTeeinblueLoading() {
    // Dynamic "Replace photo" button localization inside placement/cropper modal
    if (document.querySelector('.tee-image-placement-replace, .tee-image-cropper-replace')) {
      const replaceSpans = document.querySelectorAll('.tee-image-placement-replace span, .tee-image-cropper-replace span');
      replaceSpans.forEach(replaceSpan => {
        replaceSpan.childNodes.forEach(node => {
          if (node.nodeType === Node.TEXT_NODE && node.nodeValue.trim() !== '' && node.nodeValue.trim() !== t.replace_btn) {
            node.nodeValue = t.replace_btn;
          }
        });
      });
    }

    const rawLoadingEls = document.querySelectorAll('.tee-photo .tee-progress--loading, .tee-photo .tee-progress, .tee-photo .tee-photo-uploading, .tee-photo .tee-product-loading, .tee-product-loading');
    const loadingEls    = Array.from(rawLoadingEls).filter(el => getAiFieldMode(el) !== false);

    const isRealLoading = loadingEls.length > 0;
    const hasAi         = loadingEls.some(el => getAiFieldMode(el) === 'ai');

    let hasNewUpload = false;
    loadingEls.forEach(el => {
      if (!activeLoadingElements.has(el)) {
        activeLoadingElements.add(el);
        hasNewUpload = true;
        currentTrackingElement = el;
      }
    });

    for (const el of activeLoadingElements) {
      if (!document.body.contains(el)) {
        activeLoadingElements.delete(el);
        if (currentTrackingElement === el) currentTrackingElement = null;
      }
    }

    if (!currentTrackingElement && activeLoadingElements.size > 0) {
      currentTrackingElement = activeLoadingElements.values().next().value;
    }

    if (hasNewUpload) isClosedByUser = false;

    if (isRealLoading) {
      updatePopupMode(hasAi);
      if (!isClosedByUser) {
        if (!aiBackdrop.classList.contains('tib-active') && !showTimeout) {
          showTimeout = setTimeout(() => {
            const rawStillLoading = document.querySelectorAll('.tee-photo .tee-progress--loading, .tee-photo .tee-progress, .tee-photo .tee-photo-uploading, .tee-photo .tee-product-loading, .tee-product-loading');
            const stillLoadingEls = Array.from(rawStillLoading).filter(el => getAiFieldMode(el) !== false);
            const stillLoading    = stillLoadingEls.length > 0;
            const stillHasAi      = stillLoadingEls.some(el => getAiFieldMode(el) === 'ai');
            if (stillLoading && !isClosedByUser) {
              updatePopupMode(stillHasAi);
              showAiPopup();
            }
            showTimeout = null;
          }, 50);
        }
      }

      const trackingEl = currentTrackingElement || loadingEls[0];
      if (trackingEl) startFakeProgress();

    } else {
      isClosedByUser = false;
      currentTrackingElement = null;
      activeLoadingElements.clear();

      if (fakeProgressInterval) {
        stopFakeProgress();
        updateProgress(100); // Flash 100% before closing
      }
      if (showTimeout) {
        clearTimeout(showTimeout);
        showTimeout = null;
      }
      hideAiPopup();
    }
  }

  // MutationObserver on the Teeinblue form
  const observer = new MutationObserver(() => {
    checkTeeinblueLoading();
  });

  // High-speed body observer to translate cropper/placement dialogs instantly
  const bodyObserver = new MutationObserver(() => {
    startObserving();
    if (!document.querySelector('.tee-image-placement-replace, .tee-image-cropper-replace')) return;
    const replaceSpans = document.querySelectorAll('.tee-image-placement-replace span, .tee-image-cropper-replace span');
    replaceSpans.forEach(replaceSpan => {
      replaceSpan.childNodes.forEach(node => {
        if (node.nodeType === Node.TEXT_NODE && node.nodeValue.trim() !== '' && node.nodeValue.trim() !== t.replace_btn) {
          node.nodeValue = t.replace_btn;
        }
      });
    });
  });
  bodyObserver.observe(document.body, { childList: true, subtree: true });

  let lastObservedForm = null;
  function startObserving() {
    const form = document.querySelector('.tee-customization-form') || document.querySelector('#teeFormInputs');
    if (form && form !== lastObservedForm) {
      observer.observe(form, {
        childList: true, subtree: true,
        attributes: true, attributeFilter: ['class']
      });
      lastObservedForm = form;
      checkTeeinblueLoading();
    }
  }

  document.addEventListener("teeinblue-event-component-injected", () => { startObserving(); });

  if (
    (window.teeinblueShopConfig && window.teeinblueShopConfig.enable_for_all_pages) ||
    document.querySelector('.tee-customization-form') ||
    document.querySelector('#teeFormInputs')
  ) {
    startObserving();
  }

  let intervalId;
  function startInterval() {
    if (!intervalId) {
      intervalId = setInterval(() => { checkTeeinblueLoading(); }, 500);
    }
  }

  document.addEventListener("teeinblue-event-component-injected", startInterval);
  if (
    (window.teeinblueShopConfig && window.teeinblueShopConfig.enable_for_all_pages) ||
    document.querySelector('.tee-customization-form') ||
    document.querySelector('#teeFormInputs')
  ) {
    startInterval();
  }
}

// ── Overlay click handler for preview modals ────────────────────────
document.addEventListener('click', function (event) {
  const target = event.target;
  const isOverlayClick = target.classList.contains('vm--overlay') || target.classList.contains('vm--container');
  if (isOverlayClick) {
    const isPreviewModal = target.closest('.tee-dialog-product-mockup, .tee-dialog-gallery, [name="tee-dialog-product-mockup"]');
    if (isPreviewModal) {
      const allPreviewCloseButtons = document.querySelectorAll('.tee-dialog-product-mockup .tee-dialog-close, .tee-dialog-gallery .tee-dialog-close');
      allPreviewCloseButtons.forEach(function (closeBtn) { closeBtn.click(); });
    }
  }
}, true);

// ====================================================================
// 3. STYLES
// ====================================================================

function initCustomStyle() {
  if (document.getElementById('tib-custom-style')) return;
  const style = document.createElement('style');
  style.id = 'tib-custom-style';
  style.textContent = `

  /* ── Scroll lock ────────────────────────────────────────────────── */
  html.tib-popup-scroll-lock,
  body.tib-popup-scroll-lock {
    overflow: hidden !important;
    touch-action: none !important;
  }

  /* ── Backdrop ───────────────────────────────────────────────────── */
  .tib-ai-modal-backdrop {
    align-items: center;
    background: rgba(0, 0, 0, 0.72);
    display: flex;
    height: 100dvh;
    justify-content: center;
    left: 0;
    position: fixed;
    top: 0;
    width: 100vw;
    z-index: 999999999;
    opacity: 0;
    transition: opacity 0.3s ease;
    padding: clamp(6px, 2vw, 16px);
    box-sizing: border-box;
  }

  .tib-ai-modal-backdrop:not(.tib-active) { pointer-events: none; }

  .tib-ai-modal-backdrop.tib-active {
    opacity: 1 !important;
    touch-action: none;
  }

  .tib-ai-modal-backdrop.tib-active .tib-ai-modal-content { touch-action: none; }

  /* ── Modal shell ────────────────────────────────────────────────── */
  .tib-ai-modal-content {
    font-family: 'Poppins', 'Inter', sans-serif;
    background: #FFFFFF;
    border-radius: clamp(10px, 2vw, 16px);
    box-shadow: 0 8px 48px rgba(0, 0, 0, 0.2);
    position: relative;
    width: min(800px, 100%);
    max-height: min(600px, 95dvh);
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .tib-ai-modal-backdrop.tib-active .tib-ai-modal-content:not(.tib-closing) {
    animation: tib-modal-slide-down-in 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }

  @keyframes tib-modal-slide-down-in {
    0%  { opacity: 0; transform: translateY(-60px); }
    to  { opacity: 1; transform: translateY(0);     }
  }

  @keyframes tib-modal-slide-up-out {
    0%  { opacity: 1; transform: translateY(0);     }
    to  { opacity: 0; transform: translateY(-60px); }
  }

  .tib-ai-modal-content.tib-closing {
    animation: tib-modal-slide-up-out 0.3s cubic-bezier(0.4, 0, 0.2, 1) forwards;
  }

  /* ── Close btn (hidden by design) ──────────────────────────────── */
  .tib-ai-modal-content .tib-close-btn { display: none !important; }

  .tib-close-btn {
    position: absolute !important; top: 10px !important; right: 10px !important;
    border: none !important; background: #f0f0f0 !important;
    width: 32px !important; height: 32px !important;
    border-radius: 50% !important; display: flex !important;
    align-items: center !important; justify-content: center !important;
    cursor: pointer !important; z-index: 10 !important;
    padding: 0 !important; outline: none !important; box-shadow: none !important;
    transition: background 0.2s ease !important;
  }
  .tib-close-btn:hover { background: #e0e0e0 !important; }
  .tib-close-btn::before {
    content: "" !important;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='13' viewBox='0 0 12 13' fill='none'%3E%3Cpath d='M11 1.5L1 11.5M1 1.5L11 11.5' stroke='%23202024' stroke-width='1.66667' stroke-linecap='round' stroke-linejoin='round'%3E%3C/path%3E%3C/svg%3E") !important;
    background-size: 100% 100% !important; width: 13px !important; height: 13px !important; display: block !important;
  }

  /* ── 2-column main body ─────────────────────────────────────────── */
  .tib-popup-main-body {
    display: flex;
    flex: 1;
    min-height: 0;
    overflow: hidden;
  }

  /* ── Left panel ─────────────────────────────────────────────────── */
  .tib-popup-left {
    width: clamp(120px, 33%, 240px);
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    padding: clamp(10px, 2vw, 18px);
    padding-right: 0;
    gap: clamp(8px, 1.5vw, 14px);
    box-sizing: border-box;
  }

  .tib-popup-image-wrap {
    flex: 1;
    border-radius: clamp(6px, 1.5vw, 12px);
    overflow: hidden;
    position: relative;
    min-height: 0;
    border: 1px solid #9ca3af;
  }

  /* TSB-Begin: Dezenter Scan-Effekt über dem Vorschaubild */
  .tib-popup-image-wrap::after {
    content: "";
    position: absolute;
    left: 0;
    top: -35%;
    width: 100%;
    height: 28%;
    pointer-events: none;
    z-index: 2;

    background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 0.18),
      rgba(255, 255, 255, 0.32),
      rgba(255, 255, 255, 0.18),
      rgba(255, 255, 255, 0)
    );

    filter: blur(5px);
    opacity: 0;
    animation: tibPopupImageScan 7s ease-in-out infinite;
  }

  @keyframes tibPopupImageScan {
    0% {
      top: -35%;
      opacity: 0;
    }

    12% {
      opacity: 1;
    }

    72% {
      opacity: 1;
    }

    85% {
      top: 110%;
      opacity: 0;
    }

    100% {
      top: 110%;
      opacity: 0;
    }
  }
  /* TSB-End */

  .tib-popup-product-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    border-radius: inherit;
  }

  /* Checkerboard placeholder */
  .tib-popup-img-placeholder {
    width: 100%;
    height: 100%;
    min-height: 80px;
    border-radius: inherit;
    background-color: #f0eeee;
    background-image:
      linear-gradient(45deg, #dcdcdc 25%, transparent 25%),
      linear-gradient(-45deg, #dcdcdc 25%, transparent 25%),
      linear-gradient(45deg, transparent 75%, #dcdcdc 75%),
      linear-gradient(-45deg, transparent 75%, #dcdcdc 75%);
    background-size: 16px 16px;
    background-position: 0 0, 0 8px, 8px -8px, -8px 0px;
  }

  .tib-popup-thanks-note {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    gap: clamp(5px, 1vw, 8px);
    flex-shrink: 0;
  }

  .tib-thanks-heart-icon {
    width: clamp(14px, 2.5vw, 20px);
    height: clamp(14px, 2.5vw, 20px);
    flex-shrink: 0;
    margin-top: 1px;
  }

  .tib-thanks-title {
    font-size: clamp(8px, 1.3vw, 11px);
    font-weight: 600;
    color: #171717;
    line-height: 1.3;
  }

  .tib-thanks-sub {
    font-size: clamp(8px, 1.3vw, 11px);
    color: #6b7280;
    line-height: 1.3;
    margin-top: 2px;
  }

  /* ── Right panel ─────────────────────────────────────────────────── */
  .tib-popup-right {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    padding: clamp(10px, 2.5vw, 20px);
    padding-bottom: 0;
    gap: clamp(6px, 1.5vw, 12px);
    overflow-y: auto;
    box-sizing: border-box;
  }

  /* ── Heading ─────────────────────────────────────────────────────── */
  .tib-popup-heading {
    display: flex;
    align-items: flex-start;
    gap: clamp(6px, 1.2vw, 10px);
    flex-shrink: 0;
  }

  /* Reusing .tib-ai-video-container class — now a small icon slot */
  .tib-ai-video-container {
    width: clamp(22px, 3.5vw, 48px);
    height: clamp(22px, 3.5vw, 48px);
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 0;
  }
  .tib-ai-video-container svg { width: 100%; height: 100%; }

  /* wowYou! Brandfarben – SVG-Overrides */
  .tib-ai-video-container svg .st0,
  .tib-ai-video-container svg .st1 {
    stroke: #713F8F !important;
  }

  .tib-ai-video-container #tibHG2 stop:first-child {
    stop-color: #713F8F !important;
  }

  .tib-ai-video-container #tibHG2 stop:last-child {
    stop-color: #E99A12 !important;
  }

  .tib-step-dot-spinner circle {
    fill: #713F8F !important;
  }

  .tib-thanks-heart-icon {
    fill: #E99A12 !important;
  }

  .tib-popup-heading-texts { flex: 1; min-width: 0; }

  .tib-ai-modal-title {
    font-size: clamp(13px, 2.8vw, 20px);
    font-weight: 700;
    color: #171717;
    line-height: 1.25;
    margin: 0;
  }

  .tib-ai-subtext {
    font-size: clamp(9px, 1.4vw, 12px);
    color: #6b7280;
    margin-top: 3px;
    line-height: 1.4;
  }

  /* ── Steps list ──────────────────────────────────────────────────── */
  .tib-popup-steps-list {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .tib-popup-step {
    display: flex;
    align-items: flex-start;
    gap: clamp(6px, 1.2vw, 10px);
    min-height: clamp(42px, 8vw, 58px);
  }

  /* ── Step: left column (indicator + connector line) ─────────────── */
  /* ── Sub-column 1: Timeline (Number/Check circle + Line) ────────── */
  .tib-step-timeline-col {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-shrink: 0;
    width: clamp(20px, 3.5vw, 26px);
    padding-top: 0;
    height: 100%;
  }

  .tib-step-num-circle {
    width: clamp(18px, 3.2vw, 22px);
    height: clamp(18px, 3.2vw, 22px);
    border-radius: 50%;
    flex-shrink: 0;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    transition: all 0.3s ease;
    margin-top: clamp(6px, 1vw, 9px);
  }

  .tib-step-line {
    width: 2px;
    flex: 1;
    min-height: 100%;
    background: #e5e7eb;
    margin-top: 0;
    border-radius: 1px;
    transition: background 0.4s ease;
    display: block !important;
    top: 0;
    position: relative;
  }

  .tib-step-check-inner,
  .tib-step-num-inner {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    inset: 0;
  }

  .tib-step-check-inner svg {
    width: clamp(9px, 1.8vw, 11px);
    height: clamp(8px, 1.8vw, 10px);
  }

  .tib-step-num-inner {
    font-size: clamp(9px, 1.5vw, 11px);
    font-weight: 600;
  }

  /* ── Sub-column 2: Step Icon Circle ──────────────────────────────── */
  .tib-step-icon-col {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-shrink: 0;
    width: clamp(34px, 6vw, 44px);
    height: 100%;
    position: relative;
  }

  .tib-step-icon-circle {
    width: clamp(34px, 6vw, 44px);
    height: clamp(34px, 6vw, 44px);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: all 0.3s ease;
    z-index: 1;
  }

  .tib-step-icon-line {
    width: 2px;
    flex: 1;
    min-height: 100%;
    background: #e5e7eb;
    margin-top: 0;
    border-radius: 1px;
    transition: background 0.4s ease;
    display: block !important;
    position: relative;
  }

  .tib-step-icon-circle svg {
    width: clamp(16px, 3vw, 22px);
    height: clamp(16px, 3vw, 22px);
    transition: stroke 0.3s ease, fill 0.3s ease;
  }

  .tib-step-icon-img {
    width: clamp(16px, 3vw, 22px);
    height: clamp(16px, 3vw, 22px);
    object-fit: contain;
    display: block;
    pointer-events: none;
    user-select: none;
  }

  /* ── State: pending ──────────────────────────────────────────────── */
  .tib-popup-step[data-state="pending"] .tib-step-num-circle {
    background: #F7F7F7;
    border: 2px solid #e8e9ed;
  }
  .tib-popup-step[data-state="pending"] .tib-step-check-inner { display: none; }
  .tib-popup-step[data-state="pending"] .tib-step-num-inner   { display: flex; color: #9ca3af; }
  .tib-popup-step[data-state="pending"] .tib-step-icon-circle { background: #F7F7F7; color: #6f7884; border: 2px solid #e8e9ed }
  .tib-popup-step[data-state="pending"] .tib-step-title       { color: #9ca3af; font-weight: 500; }
  .tib-popup-step[data-state="pending"] .tib-step-sub         { color: #e8e9ed; }

  /* ── State: active ───────────────────────────────────────────────── */
  .tib-popup-step[data-state="active"] .tib-step-num-circle {
    background: #E99A12;
    border: none;
    box-shadow: 0 2px 8px rgba(113, 63, 143, 0.28);
  }
  .tib-popup-step[data-state="active"] .tib-step-check-inner { display: none; }
  .tib-popup-step[data-state="active"] .tib-step-num-inner   { display: flex; color: #ffffff; }
  .tib-popup-step[data-state="active"] .tib-step-icon-circle {
    background: #E99A12;
    color: #ffffff;
    border: 3px solid rgba(113, 63, 143, 0.14);
  }
  .tib-popup-step[data-state="active"] .tib-step-icon-circle svg { stroke: #ffffff; }
  .tib-popup-step[data-state="active"] .tib-step-icon-img { filter: brightness(0) invert(1); }
  .tib-popup-step[data-state="active"] .tib-step-title { color: #E99A12; font-weight: 700; }
  .tib-popup-step[data-state="active"] .tib-step-sub   { color: #6b7280; }

  /* ── State: done ─────────────────────────────────────────────────── */
  .tib-popup-step[data-state="done"] .tib-step-num-circle {
    background: #53943e;
    border: none;
  }
  .tib-popup-step[data-state="done"] .tib-step-check-inner { display: flex; color: #ffffff; }
  .tib-popup-step[data-state="done"] .tib-step-num-inner   { display: none; }
  .tib-popup-step[data-state="done"] .tib-step-icon-circle {
    background: #e9f1e4;
    color: #599740;
    border: 1px solid #e5eee4;
  }
  .tib-popup-step[data-state="done"] .tib-step-icon-circle svg { stroke: #599740; }
  .tib-popup-step[data-state="done"] .tib-step-title { color: #171717; font-weight: 600; }
  .tib-popup-step[data-state="done"] .tib-step-sub   { color: #9ca3af; }
  .tib-popup-step[data-state="done"] .tib-step-line,
  .tib-popup-step[data-state="done"] .tib-step-icon-line { background: #abc7a8; }

  /* ── Step body & status ──────────────────────────────────────────── */
  .tib-step-body {
    flex: 1;
    min-width: 0;
    padding-top: clamp(4px, 0.8vw, 8px);
  }

  .tib-step-title {
    font-size: clamp(10px, 2.2vw, 13px);
    font-weight: 600;
    color: #171717;
    line-height: 1.3;
    transition: color 0.25s ease;
  }

  .tib-step-sub {
    font-size: clamp(8px, 1.6vw, 11px);
    color: #9ca3af;
    line-height: 1.3;
    margin-top: 1px;
    transition: color 0.25s ease;
  }

  .tib-step-status {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    min-width: clamp(38px, 7vw, 60px);
    padding-top: clamp(4px, 0.8vw, 8px);
  }

  /* Status label visibility */
  .tib-step-done-lbl    { display: none; font-size: clamp(9px, 1.5vw, 12px); font-weight: 600; color: #16a34a; }
  .tib-step-spinner     { display: none; }
  .tib-step-pending-lbl { display: none; font-size: clamp(9px, 1.5vw, 12px); font-weight: 500; color: #9ca3af; }

  .tib-popup-step[data-state="done"]    .tib-step-done-lbl    { display: inline; }
  .tib-popup-step[data-state="active"]  .tib-step-spinner     { display: inline-flex; }
  .tib-popup-step[data-state="pending"] .tib-step-pending-lbl { display: inline; }

  /* 8-dot circular fading spinner animation */
  .tib-step-dot-spinner {
    width: clamp(16px, 2.8vw, 22px);
    height: clamp(16px, 2.8vw, 22px);
    animation: tibSpinDot 0.8s linear infinite;
    display: block;
  }

  @keyframes tibSpinDot {
    to { transform: rotate(360deg); }
  }

  /* ── Progress bar footer ─────────────────────────────────────────── */
  .tib-popup-footer-bar {
    display: flex;
    align-items: center;
    gap: clamp(6px, 1.5vw, 12px);
    padding: clamp(8px, 1.5vw, 14px) 0;
    border-top: 1px solid rgba(113, 63, 143, 0.10);
    max-width: calc(100% - clamp(12px, 2.5vw, 20px) - clamp(12px, 2.5vw, 20px));
    width: 100%;
    margin: auto;
    flex-shrink: 0;
    box-sizing: border-box;
  }

  .tib-popup-time-estimate {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: clamp(8px, 1.4vw, 11px);
    color: #6b7280;
    white-space: nowrap;
    flex-shrink: 0;
  }

  .tib-popup-time-estimate svg {
    width: clamp(10px, 1.8vw, 14px);
    height: clamp(10px, 1.8vw, 14px);
    flex-shrink: 0;
    color: #E99A12;
  }

  .tib-time-highlight { color: #E99A12; font-weight: 700; }

  /* Progress bar */
  .tib-ai-progress-bar {
    flex: 1;
    min-width: 0;
    background: rgba(113, 63, 143, 0.10);
    border-radius: 6px;
    height: clamp(8px, 1.4vw, 10px);
    overflow: hidden;
    position: relative;
  }

  .tib-ai-progress-fill {
    background: #E99A12;
    border-radius: 6px;
    height: 100%;
    overflow: hidden;
    position: relative;
    transition: width 0.2s linear;
    z-index: 1;
    display: block !important;
  }

  /* Diagonal sliding barber-pole stripes */
  .tib-ai-progress-fill:before {
    content: "";
    position: absolute;
    inset: 0;

    background-image: repeating-linear-gradient(
      -45deg,
      rgba(255, 255, 255, 0.25),
      rgba(255, 255, 255, 0.25) 8px,
      transparent 8px,
      transparent 16px
    );
    background-size: 22.6px 22.6px;
    animation: tibBarberPole 0.8s linear infinite;
  }

  @keyframes tibBarberPole {
    0%   { background-position: 0 0; }
    100% { background-position: 22.6px 0; }
  }

  .tib-ai-percent-text {
    font-size: clamp(10px, 1.8vw, 14px);
    font-weight: 700;
    color: #E99A12;
    flex-shrink: 0;
    min-width: clamp(28px, 5vw, 40px);
    text-align: right;
  }

  /* ── "Did you know?" footer card wrapper ─────────────────────────── */
  .tib-popup-dyk-wrapper {
    padding: 0 clamp(10px, 2vw, 16px) clamp(10px, 2vw, 16px);
    flex-shrink: 0;
    box-sizing: border-box;
  }

  .tib-popup-dyk {
    background: #F7F7F7;
    border: 1px solid rgba(113, 63, 143, 0.14);
    border-radius: clamp(10px, 2vw, 14px);
    padding: clamp(8px, 1.6vw, 12px) clamp(12px, 2vw, 18px);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: clamp(6px, 1.5vw, 12px);
    box-sizing: border-box;
  }

  .tib-dyk-left {
    display: flex;
    align-items: center;
    gap: clamp(8px, 1.5vw, 12px);
    flex: 1;
    min-width: 0;
  }

  .tib-dyk-icon-circle {
    width: clamp(28px, 4.5vw, 36px);
    height: clamp(28px, 4.5vw, 36px);
    border-radius: 50%;
    background: rgba(113, 63, 143, 0.10);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .tib-dyk-icon-circle svg {
    width: clamp(14px, 2.4vw, 18px);
    height: clamp(14px, 2.4vw, 18px);
    flex-shrink: 0;
    fill: #713F8F;
  }

  .tib-dyk-text {
    font-size: clamp(8px, 1.4vw, 11px);
    color: #6b7280;
    display: flex;
    flex-direction: column;
    gap: 1px;
    min-width: 0;
  }

  .tib-dyk-text strong {
    font-size: clamp(9px, 1.5vw, 12px);
    color: #171717;
    display: block;
    font-weight: 600;
  }

  .tib-dyk-text span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .tib-dyk-signature {
    font-size: clamp(11px, 2vw, 15px);
    font-style: italic;
    color: #E99A12;
    white-space: nowrap;
    font-weight: 600;
    flex-shrink: 0;
  }

  /* ── CSS custom properties for animated SVG icons (kept for compat) ─ */
  @property --ai-color-1 { syntax: "<color>"; inherits: true; initial-value: #E99A12; }
  @property --ai-color-2 { syntax: "<color>"; inherits: true; initial-value: #713F8F; }
  @property --ai-color-3 { syntax: "<color>"; inherits: true; initial-value: #F2B94E; }
  @property --ai-color-4 { syntax: "<color>"; inherits: true; initial-value: #8E62A2; }

  .animated-ai-logo {
    --ai-color-1: #E99A12; --ai-color-2: #713F8F;
    --ai-color-3: #F2B94E; --ai-color-4: #8E62A2;
    display: block;
    animation: aiGradientShift 5s linear infinite;
  }

  @keyframes aiGradientShift {
    0%   { --ai-color-1:#E99A12; --ai-color-2:#713F8F; --ai-color-3:#F2B94E; --ai-color-4:#8E62A2; transform: scale(.9); }
    25%  { --ai-color-1:#713F8F; --ai-color-2:#F2B94E; --ai-color-3:#8E62A2; --ai-color-4:#E99A12; }
    50%  { --ai-color-1:#F2B94E; --ai-color-2:#8E62A2; --ai-color-3:#E99A12; --ai-color-4:#713F8F; transform: scale(1.4); }
    75%  { --ai-color-1:#8E62A2; --ai-color-2:#E99A12; --ai-color-3:#713F8F; --ai-color-4:#F2B94E; }
    100% { --ai-color-1:#E99A12; --ai-color-2:#713F8F; --ai-color-3:#F2B94E; --ai-color-4:#8E62A2; transform: scale(.9); }
  }
   

  `;
  document.body.appendChild(style);
}

// ====================================================================
// 4. BOOTSTRAP
// ====================================================================

let initAllCalled = false;
const initAll = () => {
  if (initAllCalled) return;
  initAllCalled = true;
  initCustomStyle();
  initCustomUpload();
};

document.addEventListener("teeinblue-event-component-injected", initAll);

if (window.teeinblueShopConfig && window.teeinblueShopConfig.enable_for_all_pages) {
  if (document.readyState === "complete" || document.readyState === "interactive") {
    initAll();
  } else {
    document.addEventListener("DOMContentLoaded", initAll);
  }
}